import {
    GovTabs, GovTabsItem
} from "@gov-design-system-ce/react";
import {Variant} from "../Variant";
import React, {ReactNode} from "react";

export interface TabProps {
    type?: TabType;
    variant?: Variant;
    items: TabItem[];
}

export interface TabItem {
    label: string;
    content: ReactNode;
}

export enum TabType {
    TEXT = "text",
    CHIP = "chip"
}

export default function TabNav(props: TabProps) {
    const {items} = props;
    const type = props.type ? props.type : TabType.TEXT;
    const variant = props.variant ? props.variant : Variant.PRIMARY;

    return (
        <GovTabs type={type}
                 variant={variant}>
            {items.map((item, key) => {
                return (
                    <GovTabsItem key={"tab" + key}
                                 label={item.label}>
                        <div>
                            {item.content}
                        </div>
                    </GovTabsItem>
                );
            })}
        </GovTabs>
    );
}